import styled from 'styled-components';
import { gridSizes, media, weights } from 'utils/style';
import Header from './Header';
import Tag from 'components/Tag';

export default styled(Header)`
  padding: ${gridSizes('M')};
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${media.lessThan('extraSmall')`
        background: var(--white);
        padding: ${gridSizes('M')};
        padding-top: 12px !important;
        padding-bottom: 12px !important;
        flex-direction: row-reverse;
        border-radius: 2px;
    `};

  .reference {
    border-radius: ${gridSizes('XS')};
    padding: ${gridSizes('XS')};
    border: solid 1px var(--grey-mouse);
    display: flex;
    justify-content: center;
    display: flex;
    flex-direction: column;
    min-width: 120px;

    .label {
      font-family: Roboto;
      font-size: 14px;
      text-align: center;
      color: var(--grey700);
    }

    .shipmentId {
      text-transform: uppercase;
      font-family: Roboto;
      font-size: ${gridSizes('L')};
      font-weight: ${weights('medium')};
      letter-spacing: 0.7px;
      text-align: center;
      color: var(--grey900);
    }

    ${media.lessThan('extraSmall')`
        display: none;
    `};
  }

  .info {
    flex: 1;
    flex-direction: column;
    display: flex;
    padding: ${gridSizes('XS')} ${gridSizes('M')};

    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    & > span {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    ${media.lessThan('extraSmall')`
        padding: 0 ${gridSizes('M')};
    `};

    .shipmentId {
      display: none;

      ${media.lessThan('extraSmall')`
            display: block;
            height: ${gridSizes('M')};
            font-family: Roboto;
            font-size: 14px;
            font-weight: ${weights('medium')};
            color: var(--grey700);
        `};
    }

    .type {
      font-family: Roboto;
      font-size: ${gridSizes('M')};
      font-weight: ${weights('medium')};
      color: var(--grey700);
      margin-bottom: ${gridSizes('XS')};
      ${media.lessThan('extraSmall')`
        display: none;
    `};
    }

    .recurring {
      margin-left: -6px;
    }

    .creation {
      font-family: Roboto;
      font-size: ${gridSizes('M')};

      color: var(--grey700);

      ${media.lessThan('extraSmall')`
            width: 100%;
        height: ${gridSizes('M')};
        font-family: Roboto;
        font-size: 14px;

        font-style: normal;
        font-stretch: normal;
        line-height: normal;
        letter-spacing: normal;
        color: var(--grey900);
  `};
    }
  }

  .close {
    background: none;
    color: inherit;
    border: none;
    padding: 0;
    font: inherit;
    cursor: pointer;
    outline: inherit;

    padding: ${gridSizes('S')};
    margin-top: -6px;
    cursor: pointer;
    display: flex;
    flex-direction: column;

    ${media.lessThan('extraSmall')`
    margin: inherit;
    justify-content: center;
    align-items: center;
    `};
  }

  ${Tag} {
    width: 120px;
    text-align: center;
    margin: 0;
  }
`;
